import * as React from 'react'

import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/my-account/wishlist'

import withCms from '../../../cms/with-cms'
import withLayout from '../../../cms/with-layout'
import { withCart } from '../../../components/hocs/with-cart'

import '@grandvisionhq/fun-wishlist/styles.css'

const WishlistPage: NextPage = () => <Page />

export default compose(withCms(), withLayout(), withCart({ readOnly: true }))(WishlistPage)
